<template>
  <div class="page_legalSubject">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">公司名称</div>
            <el-input v-model="listQuery.CompanyName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">业务类型</div>
            <el-select v-model="listQuery.BusinessUnit" placeholder="" size="small" clearable>
              <el-option label="外包" value="外包"></el-option>
              <el-option label="派遣" value="派遣"></el-option>
              <el-option label="代理招聘" value="代理招聘"></el-option>
              <el-option label="猎头" value="猎头"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">注册地区</div>
            <el-input v-model="listQuery.RegisteredAddress" size="small" clearable></el-input>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="注册资金:">
            <el-select v-model="listQuery.RegisteredCapital" size="small" placeholder="" clearable>
              <el-option label="200万以下" value="200万以下"></el-option>
              <el-option label="200万以上 (含200万)" value="200万以上 (含200万)"></el-option>
              <el-option label="500万以上 (含500万)" value="500万以上 (含500万)"></el-option>
              <el-option label="1000万以上(含1000万)" value="1000万以上(含1000万)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票类型:" label-width="68px">
            <el-select v-model="listQuery.BillingType" size="small" placeholder="" clearable>
              <el-option label="全额" value="全额"></el-option>
              <el-option label="差额" value="差额"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="checkbox">
              <el-checkbox v-model="listQuery.HasHumanResoLicen" true-label="有" false-label="">人力资源许可证</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="checkbox">
              <el-checkbox v-model="listQuery.HasLaborlicense" true-label="有" false-label="">劳务派遣证</el-checkbox>
            </div>
          </el-form-item>
          <div>
            <el-form-item label="社保户:">
              <el-select v-model="listQuery.IsSsaccount" size="small" placeholder="" clearable>
                <el-option label="有" value="有"></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公积金户:" label-width="68px">
              <el-select v-model="listQuery.IsAfund" size="small" placeholder="" clearable>
                <el-option label="有" value="有"></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主体属性:" label-width="68px">
              <el-select v-model="listQuery.type" size="small" placeholder="" clearable>
                <el-option label="独立" value="0"></el-option>
                <el-option label="分公司" value="1"></el-option>
              </el-select>
            </el-form-item>
          </div>

        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统</el-breadcrumb-item>
          <el-breadcrumb-item>基础数据</el-breadcrumb-item>
          <el-breadcrumb-item>法务主体维护</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="listQuery.SubType" type="card" @tab-click="getlegalsubjectlist">
          <el-tab-pane label="内部主体" name="0"></el-tab-pane>
          <el-tab-pane label="外部主体" name="1"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;">
          <el-button type="success" size="small" @click="addLeg" v-if="checkPermission(['legalMaintenance_add_basic'],permissionLists)||checkPermission(['legalMaintenance_add_finance'],permissionLists)">&nbsp;新增</el-button>

          <el-button type="primary" size="small" @click="exportHandle" v-if="checkPermission(['legalMaintenance_add_basic'],permissionLists)||checkPermission(['legalMaintenance_add_finance'],permissionLists)" :loading="isExping">&nbsp;导出</el-button>
        </div>
        <el-table :data="tableData" style="width: 99%" border :max-height="tableHeight-100" class="doc_table" v-loading="loading">
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="CompanyName" label="公司全称" width="266" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <div class="comyName cp" @click="toDdetail(scope.row)">{{ scope.row.CompanyName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="BusinessUnit" label="业务类型" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="type" label="主体属性" width="80" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.type == true ? '独立' : row.type == false ?'分公司' : '' }}</template>
          </el-table-column>
          <el-table-column prop="RegisteredAddress" label="注册地区" width="180" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.RegisteredAddress && scope.row.RegisteredAddress.indexOf('$$')>-1 ? scope.row.RegisteredAddress.replace('$$','') : scope.row.RegisteredAddress.split('/')[0].replace(/,/g,'-') + '；' + scope.row.RegisteredAddress.split('/')[1] }}
            </template>
          </el-table-column>
          <el-table-column prop="RegisteredTime" label="成立时间" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.RegisteredTime ? scope.row.RegisteredTime.split('T')[0] : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="RegisteredCapital" label="注册资金（万）" width="130" align="center">
            <template slot-scope="{row}">
              {{ row.RegisteredCapital == 0 ? '分公司无注册资金' : row.RegisteredCapital }}
            </template>
          </el-table-column>
          <el-table-column prop="LegalPerson" label="法人/负责人" width="100" align="center">
            <!-- <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.LegalPersonId)" v-show="row.LegalPersonId && row.LegalPerson" title="点击查看联系方式">{{row.LegalPerson}}</span>
              </el-popover>
            </template> -->
          </el-table-column>
          <el-table-column prop="IsSsaccount" label="社保户" width="100" align="center">
          </el-table-column>
          <el-table-column prop="IsAfund" label="公积金户" width="100" align="center">
          </el-table-column>
          <el-table-column prop="BusinessTerm" label="营业期限" width="140" align="center">
            <template slot-scope="{row}">
              <span :class="row.BusinessTerm && row.BusinessTerm<180 ? 'warning' : ''">{{ row.BusinessTerm ? row.BusinessTerm == '长期有效' ? row.BusinessTerm : row.BusinessTerm>0 ? '剩余' + Math.ceil(row.BusinessTerm) + '天' : '已过期' + Math.ceil(-row.BusinessTerm) + '天' : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="HasHumanResoLicen" label="人力资源证" width="100" align="center">
          </el-table-column>
          <el-table-column prop="HasHumanResoLicen" label="人力资源证附件" width="120" align="center">
            <template slot-scope="scope">
              <span class="greenName cp" v-if="scope.row.HumanResoLicenUrl" @click="down(scope.row.HumanResoLicenUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="HumanResoLicenEndTime" label="人力资源证到期时间" width="140" align="center">
            <template slot-scope="{row}">
              <span :class="row.HumanResoLicenEndTime && row.HumanResoLicenEndTime<180 ? 'warning' : ''">{{ row.HumanResoLicenEndTime ? row.HumanResoLicenEndTime>0 ? '剩余' + Math.ceil(row.HumanResoLicenEndTime) + '天' : '已过期' + Math.ceil(-row.HumanResoLicenEndTime) + '天' : 
              '' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="HasLaborlicense" label="劳务派遣证" width="100" align="center">
          </el-table-column>
          <el-table-column prop="LaborlicenseUrl" label="劳务派遣证附件" width="120" align="center">
            <template slot-scope="scope">
              <span class="greenName cp" v-if="scope.row.LaborlicenseUrl" @click="down(scope.row.LaborlicenseUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="LaborlicenseEndTime" label="劳务派遣证到期时间" width="140" align="center">
            <template slot-scope="{row}">
              <span :class="row.LaborlicenseEndTime && row.LaborlicenseEndTime<180 ? 'warning' : ''">{{ row.LaborlicenseEndTime ? row.LaborlicenseEndTime>0 ? '剩余' + Math.ceil(row.LaborlicenseEndTime) + '天' : '已过期' + Math.ceil(-row.LaborlicenseEndTime) + '天' : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否商保" width="100" align="center">
            <template slot-scope="{row}">{{ row.IsCanInsure ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column fixed="right" prop="CompanyStuat" label="停止/启用" width="80" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.CompanyStuat" active-value="启用" inactive-value="停止" @change="switchStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" prop="name" label="操作" width="160" align="center">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" @click="editInfo(row)">编辑</el-button>
                <el-button type="text" @click="canInsure(row)" v-if="roletype == '0383e791-72fd-4edc-aa70-2bcadminuser' || userid=='9c895257-5e33-4888-9bd8-adb6df000066'">是否商保</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: 0,
        showDropScreen: -1, //筛选下拉框 
        loading: false,
        listQuery: {
          SubType: '0', //主体类型0:内部.1:外部
          CompanyName: '',
          BusinessUnit: '',
          HasHumanResoLicen: null,
          HasLaborlicense: null,
          BillingType: '',
          // IsCanInsure:'',
          RegisteredAddress: '',
          registeredCapitalStart: '',
          registeredCapitalEnd: '',
          pageNum: 1,
          pageSize: '10',
          type: null,
          IsAfund: null,
          IsSsaccount: null,
        },
        totalCount: 0,
        scaleList: [],
        tableData: [],
        roletype: localStorage.loginRoletype,
        isExping: false,
        gridData: [], //联系方式
        gridloading: false,
        activeName: '/legalSubjectSet',
        // 按钮权限参数
        butQuery: {
          path: '/legalMaintenance',
          powerEnName: 'system'
        },
        permissionLists: [],
        needLoading: false,
        userid: Cookies.get("userid-b"),
      };
    },
    created() {
      this.calHeight();
      this.getButtonPower()
      this.getlegalsubjectlist();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          // console.log('visible')
          // 可见时，重新查询。
          // 请求表格数据方法
          this.getlegalsubjectlist();
          this.needLoading = false;
        } else {
          // console.log('hidden')
        }
      })
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        this.loading = true;
        // if (this.listQuery.HasHumanResoLicen) {
        //   this.listQuery.HasHumanResoLicen = '有'
        // }
        // if (this.listQuery.HasLaborlicense) {
        //   this.listQuery.HasLaborlicense = '有'
        // }
        xz.getlegalsubjectlist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            // if (this.listQuery.HasHumanResoLicen == '有') {
            //   this.listQuery.HasHumanResoLicen = true
            // }
            // if (this.listQuery.HasLaborlicense == '有') {
            //   this.listQuery.HasLaborlicense = true
            // }
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
            this.tableData.forEach(element => {
              element.BusinessTerm = this.dueDays(element.BusinessTerm)
              element.HumanResoLicenEndTime = this.dueDays(element.HumanResoLicenEndTime)
              element.LaborlicenseEndTime = this.dueDays(element.LaborlicenseEndTime)
            });
          } else {
            this.$message.error('系统出错')
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getlegalsubjectlist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getlegalsubjectlist();
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      searchHandle() {
        this.getlegalsubjectlist();
        this.showDropScreen = -1
      },
      //查看详情
      toDdetail(row) {
        this.$router.push({
          path: '/legalSubjectInfo',
          query: {
            Id: row.Id,
            FinanceID: row.FinanceID
          }
        })
      },
      switchStatus(row) {
        this.loading = true;
        let data = {};
        xz.getlegalsubjectdetails(row.Id).then(res => {
          if (res.status == 'ok') {
            data = res.data.entInfo1;
            data.CompanyStuat = row.CompanyStuat;
            data.Id = row.Id;
            xz.updatelegalsubject(data).then(res => {
              if (res.status == 'ok') {
                this.getlegalsubjectlist();
                this.$message.success(row.CompanyStuat + '成功！')
                this.loading = false;
              } else {
                this.$message.error(res.msg)
                this.loading = false;
              }
            })
          }
        })

      },
      addLeg() {
        this.$router.push({
          path: "/addLegSub",
          query: {
            SubType: this.listQuery.SubType
          },
        });
      },
      exportHandle() {
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.founder = Cookies.get("userid-b");
        d.filename = '法务主体列表导出.xlsx';
        delete d.pageNum;
        delete d.pageSize;
        this.isExping = true;
        xz.SREXPFun(d, 'ExportedCompanyList/download').then(res => {
          if (res) {
            this.isExping = false;
            this.$store.dispatch('triggerRefresh');
          } else {
            this.isExping = false;
            this.$message.error(res.msg)
          }
        })
      },
      editInfo(row) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/addLegSub",
          query: {
            Id: row.Id,
            FinanceID: row.FinanceID
          },
        });
        window.open(routerUrl.href, "_blank");
      },
      getPhone(id) {
        this.gridData = [];
        this.gridloading = true;
        let dtlQuery = {
          mainuserid: '',
          useridr: id
        }
        xz.getauthJbUserDetail(dtlQuery).then(res => {
          if (res.status == 'ok') {
            this.gridData = [{
              phone: res.msg.Strmobile
            }]
          } else {
            this.$message.error('获取联系方式失败')
            this.gridData = []
          }
        })
        this.gridloading = false;
      },
      handleClick() {
        this.$router.push({
          path: this.activeName
        })
      },
      dueDays(date) {
        if (date) {
          if (date.indexOf('2999-12-31') > -1) {
            return '长期有效'
          } else {
            let days = ((new Date(date).valueOf() - new Date().valueOf()) / (24 * 60 * 60 * 1000))
            return days
          }
        } else {
          return ''
        }
      },
      canInsure(row) {
        this.loading = true;
        xz.LegalSubCanInsure(row.Id).then(res => {
          if (res.status == 'ok') {
            this.getlegalsubjectlist();
            this.$message.success('操作成功！')
            this.loading = false;
          } else {
            this.$message.error(res.msg)
            this.loading = false;
          }
        })
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .checkbox {
    height: 32px;
    line-height: 32px;
    /* width: 268px; */
    padding: 0 10px 0 30px;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .comyName {
    color: #19bd92;
  }

  .warning {
    color: red;
  }
</style>
<style>
  .page_legalSubject .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_legalSubject .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_legalSubject .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_legalSubject .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_legalSubject .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_legalSubject .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_legalSubject .screenInputs .screenInput .el-select .el-input__inner,
  .page_legalSubject .re_down_form.el-form--inline .el-form-item__content,
  .page_legalSubject .re_down_form .el-select,
  .page_legalSubject .re_down_form .el-form-item__content,
  .page_legalSubject .screenInput .el-input {
    width: 200px !important;
  }

  /* .doc_table.el-table .cell {
    padding: 0 5px;
  } */

  .page_legalSubject .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_legalSubject .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }


  .page_legalSubject .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
</style>